export default function Gallery() {
  const photos = [
    {
      alt: "Réparation fenêtre qui ferme mal Strasbourg par technicien DF PRO",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/9aad1a6f3d8f78885280704d01114eab.jpeg",
      w: 600,
      h: 400,
      seq: "ferm1",
    },
    {
      alt: "Technicien réglant les points de compression à Schiltigheim, Bas-Rhin",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/9c627c468c31bcaf6fbd1eb83db1a915.jpeg",
      w: 600,
      h: 400,
      seq: "ferm2",
    },
    {
      alt: "Remplacement joints fenêtre défectueux à Haguenau",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/ce40868f0334c840c1262eb6cbb1cf52.jpeg",
      w: 600,
      h: 400,
      seq: "ferm3",
    },
    {
      alt: "Diagnostic fenêtre qui ne ferme plus à Strasbourg",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a7367835b81050c156d963d35fd7dd13.webp",
      w: 600,
      h: 400,
      seq: "ferm4",
    },
    {
      alt: "Technicien DF PRO vérifiant l'étanchéité à Illkirch",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/1a62be410fa56940e3cc93919e661108.png",
      w: 600,
      h: 400,
      seq: "ferm5",
    },
    {
      alt: "Fenêtre réparée et bien fermée dans le Bas-Rhin",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/1a8fbabb4d01d000753c93a61c4b3baf.jpeg",
      w: 600,
      h: 400,
      seq: "ferm6",
    },
  ];

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Galerie de réalisations
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum">
            Nos <span className="font-serif italic">interventions</span> sur fenêtre qui ferme mal
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {photos.map((p) => (
            <div
              key={p.seq}
              className="rounded-2xl overflow-hidden border border-rose-200 bg-rose-50"
            >
              <img
                src={
                  p.src
                    ? p.src
                    : `https://readdy.ai/api/search-image?query=${encodeURIComponent(p.prompt)}&width=${p.w}&height=${p.h}&seq=${p.seq}&orientation=landscape`
                }
                alt={p.alt}
                className="w-full h-[260px] object-cover object-top"
              />
              <div className="px-4 py-3">
                <p className="text-xs text-plum-dark/60 italic">[PHOTO]</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}